import { getAccount, getAccounts } from '@/services/payments.service';
import { redirectNotFound } from '@/utils/errorRedirect';

const Model = {
  namespace: 'accountDetails',
  state: {
    account: null,
    accounts: [],
    isLoadingAccounts: false,
  },

  effects: {
    *fetchAccount({ payload }, { call, put }) {
      try {
        const response = yield call(getAccount, payload.pk || payload.id);
        yield put({
          type: 'show',
          payload: { account: response.data },
        });
      } catch (error) {
        redirectNotFound(error);
      }
    },
    *getAccounts({ payload }, { call, put }) {
      yield put({
        type: 'setLoadingAccounts',
        payload: true,
      });

      try {
        const response = yield call(getAccounts, payload);
        yield put({
          type: 'saveAccounts',
          payload: response.data.results,
        });
      } catch (error) {
        yield put({
          type: 'setLoadingAccounts',
          payload: false,
        });
      }
    },
  },

  reducers: {
    show(state, { payload }) {
      return { ...state, ...payload };
    },
    saveAccounts(state, { payload }) {
      return { ...state, accounts: payload, isLoadingAccounts: false };
    },
    setLoadingAccounts(state, { payload }) {
      return { ...state, isLoadingAccounts: payload };
    },
  },
};
export default Model;
